import React from "react"

function IconLeftArrow() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>triangle-left</title><g fill="#000000"><path d="M17.447,2.105a1.006,1.006,0,0,0-1.047.1l-12,9a1,1,0,0,0,0,1.6l12,9A1,1,0,0,0,18,21V3A1,1,0,0,0,17.447,2.105Z" fill="#111111"></path></g></svg>
  )
}

export default IconLeftArrow